$(document).ready(function () {
	
  
  //open external links in new tab
	var links = document.links;
	for (let i = 0, linksLength = links.length; i < linksLength; i++) {
		if (links[i].hostname !== window.location.hostname) {
			links[i].target = '_blank';
			links[i].rel = 'noreferrer noopener';
		}
	}

	// Add smooth scrolling
	var hashTagActive = "";
	$(".smooth-scroll").on("click touchstart", function (event) {
		if (hashTagActive != this.hash) { //this will prevent if the user click several times the same link to freeze the scroll.
			event.preventDefault();
			//calculate destination place
			var dest = 0;
			if ($(this.hash).offset().top > $(document).height() - $(window).height()) {
				dest = $(document).height() - $(window).height();
			} else {
				dest = $(this.hash).offset().top;
			}
			//go to destination
			$('html,body').animate({
				scrollTop: dest
			}, 2000, 'swing');
			hashTagActive = this.hash;

			//close menu
			$("#Details-menu-drawer-container").removeClass("menu-opening").removeAttr("open");
		}
	});

    $(".show-more-btn").click(function(){
      $(this).hide();
      // $(".show-more-content").show();
      $(this).next().show();
    });
});